module.exports = __webpack_public_path__ + "img/btg.03abd0e4.svg";